const closeModalUpdate = (modal, closes, overlay, delay) => {
  if(delay != true){
    window.addEventListener('click', e => {
      if (modal.classList.contains('active') && !modal.contains(e.target)) {
        modal.classList.remove('active');
        overlay.classList.remove('active');
        handleEnableScroll();
        window.scroll({
          top: 0,
          left: 0,
        });
        if (window.location.pathname == '/expert/individual-register') {
          window.location.href = '/expert/admin-permission ';
        }
      }
    })
  }
  closes.forEach(close => {
    close.addEventListener('click', () => {
        modal.classList.remove('active');
        overlay.classList.remove('active');
        handleEnableScroll();
        window.scroll({
          top: 0,
          left: 0,
        });
        if (window.location.pathname == '/expert/individual-register') {
          window.location.href = '/expert/admin-permission ';
        }
      })
  })
}

function handleDisableScroll() {
  const eleHtml = document.querySelector('html');
  eleHtml.style.overflowY = 'hidden';
}

function handleEnableScroll() {
  const eleHtml = document.querySelector('html');
  eleHtml.style.overflowY = 'visible';
}

const modalUpdate = ({button_id, modal_id, overlay_id, delay}) => {
  const button = document.getElementById(button_id);
  const modal = document.getElementById(modal_id);
  const overlay = document.getElementById(overlay_id);
  const closes = modal.querySelectorAll('.close');
  if (button && modal && overlay && closes) {
    modal.classList.add('active');
    overlay.classList.add('active');
    handleDisableScroll();
    closeModalUpdate(modal, closes, overlay, delay);
    if(delay){
      modal.classList.add('delay');
      setTimeout(() => {
        modal.classList.remove('delay');
      }, 1500);
    }
  }
}

export default modalUpdate;
